import {useEffect, useState} from '@wordpress/element';
import {CompareBar} from './CompareBar';
import {CompareDialog} from './CompareDialog';

export const CompareHost = ({disableBar = false}) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onOpen = () => setOpen(true);
        window.addEventListener('epi:compare:open', onOpen);
        return () => window.removeEventListener('epi:compare:open', onOpen);
    }, []);

    return (
        <>
            {!disableBar && <CompareBar onOpen={() => setOpen(true)}/>}
            <CompareDialog open={open} onClose={() => setOpen(false)}/>
        </>
    );
};
